import { clsx } from "clsx"
import {
  ComponentPropsWithoutRef,
  ElementRef,
  forwardRef,
  ReactNode
} from "react"
import styled from "styled-components"
import { ButtonRoot } from "./styles"

export interface IIconButtonProps extends ComponentPropsWithoutRef<"button"> {
  color?: "primary" | "secondary"
  icon?: ReactNode
  children?: ReactNode
}

export const IconButton = forwardRef<ElementRef<"button">, IIconButtonProps>(
  ({ color = "primary", icon, children, className, ...props }, ref) => {
    return (
      <ButtonRoot ref={ref} className={clsx(className, color)} {...props}>
        <span className="btn-text">{children}</span>
        {icon && <span className="btn-icon">{icon}</span>}
      </ButtonRoot>
    )
  }
)

export const BannerButton = styled(IconButton)``
